<template>
  <div id="player" class="player-container">
    <video
      id="player-video"
      controls
      crossorigin
      playsinline
      muted
      class="video-play"
      :poster="posterUrl"
    ></video>
    <div class="ads-container">
      <!--            control scene-->
      <div
        v-if="videoPlr && isControlScene"
        @mouseleave="onHoverControlScene"
        id="control-scene"
        class="row no-gutters control-scene justify-space-around align-center"
      >
        <v-col cols="auto" class="mr-3">
          <svg
            @click="handlePreScene"
            class="arrow-left"
            :width="videoPlr.clientWidth / 7 / 2 - 10"
            style="max-width: 50px; min-width: 20px"
            viewBox="0 0 47 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.16126 37.1787C0.0654501 35.5778 0.06545 32.4222 2.16126 30.8213L40.3219 1.67123C42.9542 -0.339548 46.75 1.53747 46.75 4.84993L46.75 63.1501C46.75 66.4625 42.9542 68.3396 40.3219 66.3288L2.16126 37.1787Z"
              fill="white"
            />
          </svg>
        </v-col>
        <v-col cols="auto">
          <svg
            class="arrow-right"
            @click="handleNextScene"
            :width="videoPlr.clientWidth / 7 / 2 - 10"
            style="max-width: 50px; min-width: 20px"
            viewBox="0 0 47 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M44.8387 30.8213C46.9345 32.4222 46.9345 35.5778 44.8387 37.1787L6.67814 66.3288C4.04581 68.3395 0.25 66.4625 0.25 63.1501L0.25 4.84992C0.25 1.53746 4.04581 -0.339554 6.67814 1.67123L44.8387 30.8213Z"
              fill="white"
            />
          </svg>
        </v-col>
      </div>
      <div
        v-if="!isOpenMissionBoard && isMission"
        @click="openMissionBoard"
        class="drawer-mission"
      >
        <img src="../../../assets/drawer.gif" alt="" />
      </div>

      <div v-if="isOpenMissionBoard" class="mission-board wow fadeInLeftBig">
        <div class="header-mission-board">
          <div class="title-header-mission">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="$emit('showTutorial')"
                  >{{ mdiInformationOutline }}</v-icon
                >
              </template>
              <span>Hướng dẫn làm nhiệm vụ</span>
            </v-tooltip>

            Nhiệm vụ của bạn
          </div>

          <v-icon medium @click="closeMissionBoard">
            {{ mdiWindowClose }}</v-icon
          >
        </div>
        <div class="toggle-hint">
          <div>
            <label>Đề xuất gợi ý trong lúc làm nhiệm vụ</label>
            <span
              >Đề xuất gợi ý trong lúc làm nhiệm vụ Khi dùng tính năng này, số
              điểm sẽ giảm một nửa</span
            >
          </div>
          <div>
            <v-switch v-model="isHint" inset></v-switch>
          </div>
        </div>
        <div class="content-mission-board">
          <div class="title-mission">
            <div class="image-mission">
              <img src="../../../assets/bigStar.png" />
            </div>
            <div class="text-mission">
              <span>{{ missionDetails.nameMission }}</span>
              <div class="progress-point">
                <div>{{ missionDetails.point }}</div>
                <img src="../../../assets/startPoint2.svg" />
                <v-progress-linear
                  :value="missionDetails.percent"
                ></v-progress-linear>
              </div>
            </div>
          </div>

          <div v-if="missionDetails.isFinish" class="list-item-mission">
            <div class="item-mission">
              <div v-if="missionDetails.isFinish" class="image-mission">
                <img :src="missionDetails.image" alt="" srcset="" />
              </div>
              <div v-if="missionDetails.isFinish" class="text-mission">
                <span>{{ missionDetails.name }}</span>
                <div class="sub-description">
                  {{ missionDetails.description }}
                </div>
                <a
                  :href="missionDetails.url"
                  target="_blank"
                  class="link-details"
                  @click="$emit('pauseVideo')"
                  >Xem Chi Tiết
                  <v-icon small>{{ mdiChevronRightCircleOutline }}</v-icon></a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-mission-board">
          <a
            href="/showcase/screen-award-mission"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              v-if="missionDetails.isFinish"
              class="button-bottom-award"
              @click="$emit('pauseVideo')"
            >
              <span>Xem quà</span>
            </button></a
          >
        </div>
      </div>
      <!--            ads -->
      <slot name="ads"></slot>
      <slot name="tutorial"></slot>
      <slot name="pointAward"></slot>
    </div>
  </div>
</template>

<script>
import { mdiChevronRight } from "@mdi/js";
import { mdiWindowClose } from "@mdi/js";
import { mdiChevronUp } from "@mdi/js";
import { mdiChevronDown } from "@mdi/js";
import { mdiInformationOutline } from "@mdi/js";
import { mdiChevronRightCircleOutline } from "@mdi/js";
import { mdiCarShiftPattern } from "@mdi/js";
export default {
  name: "Player",
  props: {
    posterUrl: {
      type: String,
      default: "#",
    },
    isControlScene: {
      type: Boolean,
      default: false,
    },
    isHintItem: {
      type: Boolean,
      default: false,
    },
    isMission: {
      type: Boolean,
      default: false,
    },
    videoPlr: {
      type: HTMLVideoElement,
      default: function () {
        return {};
      },
    },
    missionDetails: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    handleNextScene() {
      this.$emit("nextScene");
    },
    handlePreScene() {
      this.$emit("preScene");
    },
    onHoverControlScene() {
      this.$emit("hoverControlScene");
    },
    openMissionBoard() {
      this.isOpenMissionBoard = true;
    },
    closeMissionBoard() {
      this.isOpenMissionBoard = false;
    },
    pushToPageRedeem() {
      this.$router.push({ name: "AwardMision" });
    },
  },
  computed: {
    isHint: {
      get() {
        return this.isHintItem;
      },
      set() {
        this.$emit("itemHint");
      },
    },
  },
  data() {
    return {
      mdiChevronRight: mdiChevronRight,
      mdiWindowClose: mdiWindowClose,
      isOpenMissionBoard: false,
      mdiChevronUp: mdiChevronUp,
      mdiChevronDown: mdiChevronDown,
      mdiInformationOutline: mdiInformationOutline,
      valueDeterminate: 50,
      isExpandedListMission: false,
      mdiChevronRightCircleOutline: mdiChevronRightCircleOutline,
      mdiCarShiftPattern: mdiCarShiftPattern,
    };
  },
};
</script>

<style scoped></style>
